export const hasRepeatingOrSequentialChars = (password: string): boolean => {
  const repeatingRegex = /(.)\1{2,}/;
  const sequentialRegex =
    /(?:012|123|234|345|456|567|678|789|890|abc|bcd|cde|def|efg|fgh|ghi|hij|ijk|jkl|klm|lmn|mno|nop|opq|pqr|qrs|rst|stu|tuv|uvw|vwx|wxy|xyz|ZYX|WVU|UTS|SRQ|PON|MNO|LKJ|IHG|FED|CBA)/;

  return repeatingRegex.test(password) || sequentialRegex.test(password);
};
